import React from 'react'
import LoadingSpinner from '../common/LoadingSpinner'
import './DeleteConfirmModal.scss'

const DeleteConfirmModal = ({
  product,
  isOpen,
  onClose,
  onConfirm,
  loading,
}) => {
  if (!isOpen || !product) return null

  return (
    <div className='modal-overlay'>
      <div className='modal-content sm'>
        <div className='modal-header'>
          <h2 className='modal-title'>Confirmer la suppression</h2>
          <div className='form-group'>
            <p>
              Êtes-vous sûr de vouloir supprimer le produit "{product.name}" ?
            </p>
            <p className='text-sm' style={{ color: '#dc2626' }}>
              Cette action est irréversible.
            </p>
            <div className='form-row pt-4'>
              <button
                onClick={onClose}
                className='btn outline flex-1'
                disabled={loading}
              >
                Annuler
              </button>
              <button
                onClick={onConfirm}
                className='btn danger flex-1'
                disabled={loading}
              >
                {loading ? (
                  <>
                    <LoadingSpinner size='sm' />
                    Suppression...
                  </>
                ) : (
                  'Supprimer'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteConfirmModal
